// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multiselect__placeholder{float:right}.custom__tag{display:inline-block;padding:3px 12px;background:#d2d7ff;margin-right:8px;margin-bottom:8px;border-radius:10px;cursor:pointer}.custom__tag:hover{background:#eaeaea}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
